import Swal from 'sweetalert2';

export const WarningModal = ({
    title,
    text,
    icon = "warning"
}) => {
    Swal.fire({
        title : title,
        text: text,
        icon: icon,
        showCancelButton: false,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
      })

    return <></>;
}